import React from 'react';

import { BEIAN_URL } from './constant';
import './index.css';

export default function BeiAn() {
    const toBeiAnWebsite = () => {
        window.open(BEIAN_URL)
    }
    return <div className="beian-container">
        <div className="beian-body" onClick={toBeiAnWebsite}>
            <span style={{
                marginRight: 2
            }}>豫ICP备</span>
            <span>2022021092号-1</span>
        </div>
    </div>
}